// List actions
export const GET_ORDER_VEHICLE_LIST = 'GET_ORDER_VEHICLE_LIST'
export const GET_ORDER_VEHICLE_LIST_OK = 'GET_ORDER_VEHICLE_LIST_OK'
export const GET_ORDER_VEHICLE_LIST_ERR = 'GET_ORDER_VEHICLE_LIST_ERR'
export const DO_ORDER_VEHICLE_LIST_CLEANUP = 'DO_ORDER_VEHICLE_LIST_CLEANUP'

// Add actions
export const ADD_ORDER_VEHICLE = 'ADD_ORDER_VEHICLE'
export const ADD_ORDER_VEHICLE_OK = 'ADD_ORDER_VEHICLE_OK'
export const ADD_ORDER_VEHICLE_ERR = 'ADD_ORDER_VEHICLE_ERR'

// Update actions
export const EDIT_ORDER_VEHICLE = 'EDIT_ORDER_VEHICLE'
export const EDIT_ORDER_VEHICLE_OK = 'EDIT_ORDER_VEHICLE_OK'
export const EDIT_ORDER_VEHICLE_ERR = 'EDIT_ORDER_VEHICLE_ERR'

// Delete actions
export const DELETE_ORDER_VEHICLE = 'DELETE_ORDER_VEHICLE'
export const DELETE_ORDER_VEHICLE_OK = 'DELETE_ORDER_VEHICLE_OK'
export const DELETE_ORDER_VEHICLE_ERR = 'DELETE_ORDER_VEHICLE_ERR'